

























import { defineComponent, type PropType } from "vue-demi";
import debounce from "lodash.debounce";

export default defineComponent({
  name: "ScaleChild",
  props: {
    width: {
      type: String as PropType<string>,
      default: "auto",
    },
    childWidth: {
      type: String as PropType<string>,
      required: true,
    },
    resize: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
  },
  data() {
    return {
      wrapperWidth: null,
      scale: 1,
      ratio: 0,
      active: false,
    };
  },
  mounted() {
    window.setTimeout(() => {
      this.calculate();
    }, 0);

    const debounceCalculate = debounce(() => {
      this.calculate();
    }, 500);

    /**
     * Порой внутри ScaleChild'a есть картинки или видео и чтобы грамотно просчитать их размер,
     * нужно подождать пока они загрузятся
     */
    const $wrapper = this.$refs.wrapper as HTMLElement;
    const image = $wrapper.querySelectorAll("img");
    if (image.length) {
      image.forEach((el) => {
        el.addEventListener("load", () => {
          debounceCalculate();
        });
      });
    }

    const video = $wrapper.querySelectorAll("video");
    if (video.length) {
      video.forEach((el) => {
        el.addEventListener("canplay", () => {
          debounceCalculate();
        });
      });
    }

    if (this.resize) {
      window.addEventListener("resize", this.calculate);
    }
  },
  methods: {
    calculate() {
      this.active = false;
      const $wrapper = this.$refs.wrapper as HTMLElement;
      const $child = this.$refs.child as HTMLElement;
      if (!$child?.children[0]) return;

      const wrapperWidth = $wrapper.offsetWidth;
      const childWidth = ($child.children[0] as HTMLElement).offsetWidth;
      const childHeight = ($child.children[0] as HTMLElement).offsetHeight;
      this.ratio = childHeight / childWidth;
      this.scale = Math.min(
        wrapperWidth > childWidth ? 1 : wrapperWidth / childWidth
      );
      this.active = true;
    },
  },
});
